import { useFrontendAPIErrorEffect } from '@edreamsodigeo/frontend-core';
import useFrontendApiLoggedError from './useFrontendApiLoggedError';

const useFrontendErrorLogged = (errors, id) => {
  useFrontendApiLoggedError(errors, id);
  useFrontendAPIErrorEffect(errors);
};

export default useFrontendErrorLogged;
